import {apiGetBuysByFactor} from "api/reportApi";
import InvoiceUpperComponent from "components/Reports/InvoiceUpperComponent";
import Table from "components/Table";

const SellInvoiceUpperSection = () => {
    return <InvoiceUpperComponent refetch={apiGetBuysByFactor} type="buysByFactor"/>;
};

export default function BuysByInvoice() {
    return (
        <div className="wrap-journal">
            {/* @ts-ignore */}
            <Table type="buysByFactor" MidComponent={SellInvoiceUpperSection}/>
        </div>
    );
}
